module.exports = {"id":"220395","name":"Álex Mula","rating":"73","photo":"./data/images/photos/0/220395.png","club":{"name":"CD Tenerife","logo":"./data/images/clubs/CDTenerife.png"},"positions":["MG","MD","BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlexMula0.json
// module id = 214
// module chunks = 0